/**
 * Cart persistence for online orders (bookMealData).
 * Persisted on every cart change; restored when Order screen loads.
 */
import AsyncStorage from '@react-native-async-storage/async-storage';

export const BOOK_MEAL_DATA_KEY = 'bookMealData';

export interface StoredCartItem {
  id: number;
  quantity: number;
  price: number;
  name?: string;
  description?: string;
  attachment?: string;
  image?: string;
  a_name?: string;
  a_description?: string;
}

export async function getBookMealData(): Promise<StoredCartItem[] | null> {
  try {
    const raw = await AsyncStorage.getItem(BOOK_MEAL_DATA_KEY);
    if (!raw) {return null;}
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : null;
  } catch {
    return null;
  }
}

export async function setBookMealData(items: StoredCartItem[]): Promise<void> {
  try {
    await AsyncStorage.setItem(BOOK_MEAL_DATA_KEY, JSON.stringify(items));
  } catch {
    // ignore
  }
}

export async function clearBookMealData(): Promise<void> {
  try {
    await AsyncStorage.removeItem(BOOK_MEAL_DATA_KEY);
  } catch {
    // ignore
  }
}
